import React, { Component } from 'react';
import './about.css'
import { Card, CardText } from 'material-ui/Card';
import Pulse from 'react-reveal/Pulse';

class About extends Component {
    constructor(props) {
        super(props)
        this.state = {
            counter:0
        }
    }
    componentDidMount() {
        setInterval(()=>{
            this.setState({
                counter:this.state.counter+1
            })
        },3000)
    }
  
    render() {
        return (
            <div className='AboutMainDiv'>

             
                <Pulse spy={this.state.counter}>
                <div className='AboutMainDivChild1'>

                    <Card className='aboutDiv'>
                        {/* <p className='aboutPara'>  */}
                        <CardText className='aboutPara'>
                            Results- oriented, meticulous and innovative Web & Mobile Application Developer from Karachi, Pakistan.
                <br />
                <hr/>
                            I am one of few developers which are working on latest technologies and trends. I am always working on new technologies and try to apply them to my work so that my clients can get benefit of it.
                <br />
                <hr/>

                            I have excellent skills and Passionate to work on latest Web & Mobile Technologies to build products of high quality user experience and of great performance.
                            </CardText>
                        {/* </p> */}

                    </Card>
                </div>
                    </Pulse>
                  
            </div>
        );
    }
}

export default About;



// WEBPACK FOOTER //
// ./src/containers/about/about.js